import cn from 'classnames'
import React, { HTMLAttributes } from 'react'

import Gap from '@/common/components/Gap'
import { numberToString } from '@/common/utils/string'
import NearbyPlaceSymbol from '@/modules/property/pages/PlaceDetailPage/components/NearbyPlaceSymbol'

interface NearbyPlaceDetailProps extends HTMLAttributes<HTMLDivElement> {
  nearbyPlace: RentAPerfect.NearbyPlace
  selected?: boolean
}

const NearbyPlaceDetail = ({
  className,
  nearbyPlace,
  selected,
  ...props
}: NearbyPlaceDetailProps) => {
  return (
    <Gap {...props} className={cn(className, 'align-center')} space={12}>
      <NearbyPlaceSymbol type={nearbyPlace.type} selected={selected} />
      <Gap className='flex-1' space={2} vertical>
        <div className='text-14 text-semibold'>{nearbyPlace.name}</div>
        <div className='text-gray text-12 text-medium'>
          {numberToString(nearbyPlace.distance)} m
        </div>
      </Gap>
    </Gap>
  )
}

export default NearbyPlaceDetail
